// extracted by mini-css-extract-plugin
module.exports = {"more":"UserProfileViewBooks__more"};